'use client';

import { useEffect, useState } from 'react';

/**
 * Vorgabe-Titel und -Beschreibung — solange keine Seite eigene setzt.
 *
 * Bis zur Next.js-Migration standen beide statisch in `index.html`, mit
 * `data-rh`, und react-helmet-async ERSETZTE sie, sobald eine Seite eigene
 * setzte. Unter React 19 tut Helmet das nicht mehr: Version 3 rendert die Tags
 * einfach, React hängt sie in den Kopf, und es standen zwei Titel und zwei
 * Beschreibungen da (gemessen 02.10.2026, Prod hat je einen). Version 2 unter
 * React 19 tut dagegen still GAR NICHTS — Titel blieb „Paperball“ auf jeder
 * Seite.
 *
 * Deshalb hier: Die Vorgaben stehen im ausgelieferten HTML (für Leser ohne
 * JavaScript) und ziehen sich zurück, sobald im Kopf ein Titel oder eine
 * Beschreibung erscheint, die nicht von hier kommt. Zurückgezogen wird durch
 * Nicht-mehr-Rendern — React entfernt dann seine eigenen Elemente; fremde
 * Knoten fasst dieser Baustein nie an. Wächter:
 * `backend/tests/test_startseite_canon.py::test_keine_zweite_beschreibung_im_kopf`.
 */

const TITEL = 'Paperball';
const BESCHREIBUNG = 'Paperball - Analyze. Compare. Share.';

interface Stand {
  titel: boolean;
  beschreibung: boolean;
}

function fremdeImKopf(): Stand {
  const fremd = (selektor: string) =>
    [...document.head.querySelectorAll(selektor)].some((el) => !el.hasAttribute('data-standard'));
  return { titel: fremd('title'), beschreibung: fremd('meta[name="description"]') };
}

export default function StandardKopf() {
  // Auf dem Server und beim ersten Rendern im Browser: keine fremden — die
  // Vorgaben stehen im HTML.
  const [fremd, setFremd] = useState<Stand>({ titel: false, beschreibung: false });

  useEffect(() => {
    const pruefen = () => {
      const stand = fremdeImKopf();
      setFremd((alt) =>
        alt.titel === stand.titel && alt.beschreibung === stand.beschreibung ? alt : stand,
      );
    };
    pruefen();
    const beobachter = new MutationObserver(pruefen);
    beobachter.observe(document.head, { childList: true });
    return () => beobachter.disconnect();
  }, []);

  return (
    <>
      {!fremd.titel && <title data-standard="">{TITEL}</title>}
      {!fremd.beschreibung && (
        <meta name="description" content={BESCHREIBUNG} data-standard="" />
      )}
    </>
  );
}
